(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminClientAdminEditSettingsController', AdminClientAdminEditSettingsController);

    function AdminClientAdminEditSettingsController(
        $controller,
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        elbSettings,
        module,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'client_admin_domains'
            ],
            elbSettings: elbSettings,
            module: module,
            fileTypeService: fileTypeService,
            buildTabSettingFormTypes: () => ({
                'client_admin_domains': { type: 'textarea', subLabel: 'CLIENT_ADMIN_DOMAIN_SUB_LABEL', rows: 5 }
            }),
            validateTabSettings: (vm) => {
                const key = 'client_admin_domains';
                if (!vm.settingsForm[key]) {
                    return true;
                }

                const domains = vm.settingsForm[key].split(',').map(domain => domain.trim()).filter(Boolean);
                const domainRegex = /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
    
                if (domains.some(domain => !domainRegex.test(domain))) {
                    messenger.error('INVALID_DOMAINS_FOUND');
                    return false;
                }

                if (new Set(domains).size !== domains.length) {
                    messenger.error('DUPLICATE_DOMAINS_FOUND');
                    return false;
                }

                vm.settingsForm[key] = domains.join(', ');
                return true;
            }
        });
        angular.extend(vm, base);
    }
})();
